export const DISCORD_PREFIX = '@discord/';
export const DISCORD_ADD_SPECIAL_ROLE = `${DISCORD_PREFIX}ADD_SPECIAL_ROLE`;
